/* unplugin-vue-components disabled */import { render } from "./Main.vue?vue&type=template&id=44be0c3e"
const script = {}

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__